import { Box, Menu, MenuItem, Modal } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { USER_ROLES } from "../../../data/constants";
import { AGGREGATOR_FEATURES_MAP } from "../../../data/outlet-status-constants";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import { getAvailableFeaturesList } from "../../../helpers/outlet-status-helper";
import { isAdminUser } from "../../../helpers/user-info-helpers";
import "./style.scss";

interface Props {
  handleMenuClose: any;
  moreOptionsMenuData: any;
  updateMoreOptionsMenuData: any;
}
const OutletOptionsMenu = (props: Props) => {
  const { handleMenuClose, moreOptionsMenuData, updateMoreOptionsMenuData } =
    props;
  const open: boolean = Boolean(moreOptionsMenuData?.anchorEl),
    anchorEl: null | HTMLElement = moreOptionsMenuData?.anchorEl || null,
    outletData = moreOptionsMenuData?.outletData || {};

  const onOptionClick = (e: any, selectedOptionId: string) => {
    updateMoreOptionsMenuData({ selectedOptionId });
    handleMenuClose(e);
  };

  function renderMoreOptionsList() {
    let availableFeaturesList = getAvailableFeaturesList(
      outletData?.type,
      outletData?.webhookSourceType
    );
    let excludedFeaturesList = [
      AGGREGATOR_FEATURES_MAP.activity_log.id,
      AGGREGATOR_FEATURES_MAP.outlet_status.id,
      AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
      AGGREGATOR_FEATURES_MAP.refresh_cta.id,
      AGGREGATOR_FEATURES_MAP.health_hub_cta_payload.id,
    ];
    if (!isAdminUser()) {
      excludedFeaturesList = excludedFeaturesList.concat(
        AGGREGATOR_FEATURES_MAP.edit_configuration.id
      );
    }
    return availableFeaturesList?.length
      ? availableFeaturesList.map((optionId: string) => {
          return excludedFeaturesList.indexOf(optionId) === -1 ? (
            <MenuItem
              onClick={(e) => onOptionClick(e, optionId)}
              key={`key-${optionId}`}
              className="text-14 text-black/70 py-[16px] leading-none"
              divider={true}
            >
              {AGGREGATOR_FEATURES_MAP[optionId].text ||
                AGGREGATOR_FEATURES_MAP[optionId].id}
            </MenuItem>
          ) : null;
        })
      : null;
  }

  function renderMoreOptionsForMobile() {
    return (
      <Modal open={open} onClose={handleMenuClose}>
        <Box
          className={`outlet-more-options-menu-modal absolute rounded-t-[8px] overflow-y-auto
            left-0 right-0 bottom-0 bg-white w-full max-h-[90%] min-h-[25%] pb-[12px]
          `}
        >
          <MenuItem
            disabled
            className="flex items-center justify-between sm:opacity-100 sm:pb-[16px]"
            divider={!!isMobileDevice()}
          >
            <p className="text-13 sm:text-black sm:font-semibold">
              More Options
            </p>
            {isMobileDevice() ? (
              <div
                className="rista-sprite ic-cross-black pointer-events-auto"
                onClick={handleMenuClose}
              ></div>
            ) : null}
          </MenuItem>
          {renderMoreOptionsList()}
        </Box>
      </Modal>
    );
  }

  function renderMoreOptionsForDesktop() {
    return (
      <Menu
        id="outlet-more-options-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": `outlet-more-options-menu-icon-${outletData?.id}`,
        }}
        PaperProps={{
          style: {
            width: "240px",
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem disabled>More Options</MenuItem>
        {renderMoreOptionsList()}
      </Menu>
    );
  }

  return open ? (
    <>
      {isMobileDevice()
        ? renderMoreOptionsForMobile()
        : renderMoreOptionsForDesktop()}
    </>
  ) : null;
};

export default OutletOptionsMenu;
